import { PRESSURE_VALUE_TYPE } from './irrigationActivityConstants'

export const isPressureValueType = (valueType: string | null | undefined) => valueType === PRESSURE_VALUE_TYPE
